import {Text} from 'platform/foundation';
import {match} from 'ts-pattern';

import {always, isEmpty, isNotEmpty} from 'ramda';

import {PurchasePriceRuleScope} from '@dms/api/sales';
import {i18n} from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {usePurchasePriceRuleScopeLabels} from '../../../hooks/usePurchasePriceRuleScopeLabels';

const LABEL_SEPARATOR = ', ';

interface PurchasePriceRuleScopeSummaryProps extends TestIdProps {
  scope: PurchasePriceRuleScope;
}

export function PurchasePriceRuleScopeSummary(props: PurchasePriceRuleScopeSummaryProps) {
  const getLabel = usePurchasePriceRuleScopeLabels(props.scope);

  if (isEmpty(props.scope.makes)) {
    return null;
  }

  const summaryKey = match([isNotEmpty(props.scope.modelFamilies), isNotEmpty(props.scope.trims)])
    .with([false, false], always('page.settings.purchasePrice.ruleEditor.scope.summary.makes'))
    .with(
      [true, false],
      always('page.settings.purchasePrice.ruleEditor.scope.summary.makesAndModelFamilies')
    )
    .with(
      [false, true],
      always('page.settings.purchasePrice.ruleEditor.scope.summary.makesAndTrims')
    )
    .with(
      [true, true],
      always('page.settings.purchasePrice.ruleEditor.scope.summary.makesModelFamiliesAndTrims')
    )
    .exhaustive();

  const joinLabels = (keys: string[]) => keys.map(getLabel).join(LABEL_SEPARATOR);

  return (
    <Text size="small" color="secondary" data-testid={props['data-testid']}>
      {i18n.t(summaryKey, {
        makes: joinLabels(props.scope.makes),
        modelFamilies: joinLabels(props.scope.modelFamilies),
        trims: joinLabels(props.scope.trims),
      })}
    </Text>
  );
}
